var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Processing",
    { attrs: { processing: _vm.processing } },
    [
      _c(
        "Card",
        {
          attrs: {
            cardClass: "border border-gray-300 shadow-sm hover:border-blue",
          },
        },
        [
          _c("div", { staticClass: "flex w-full flex-col flex-wrap p-4" }, [
            _c("div", { staticClass: "flex flex-col flex-initial" }, [
              _c(
                "div",
                {},
                [
                  _c(
                    "RouterLink",
                    { attrs: { to: _vm.contractorDetailsLink } },
                    [
                      _c("ResourceAvatar", {
                        staticClass: "cursor-pointer text-primary-500",
                        attrs: {
                          image: _vm.contractorAvatar,
                          initial: _vm.contractorInitials,
                          avatarClasses: "h-8 w-8",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex-1 py-3" },
                [
                  _c(
                    "RouterLink",
                    {
                      staticClass: "w-64 block",
                      attrs: { to: _vm.contractorDetailsLink },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "blueLabel truncate font-Outfit text-base font-medium",
                        },
                        [_vm._v(" " + _vm._s(_vm.contractorTitle) + " ")]
                      ),
                    ]
                  ),
                  _vm.contractorLocation
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "flex justify-flex-start items-center text-storm-gray text-sm adjustWidth font-medium mb-5",
                        },
                        [
                          _c("LocationIconNew", {
                            staticClass: "pr-2 w-auto h-auto",
                          }),
                          _vm._v(_vm._s(_vm.contractorLocation) + " "),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.contractorSatus
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "flex justify-flex-start items-center text-storm-gray text-sm font-medium mb-1",
                        },
                        [
                          _c("ProfileIcon", {
                            staticClass: "pr-2 w-auto h-auto",
                          }),
                          _c(
                            "span",
                            {
                              staticClass:
                                "text-primary-black font-400 text-sm pr-2",
                            },
                            [_vm._v("ProveraCare profile")]
                          ),
                          _vm._v(_vm._s(_vm.contractorSatus) + " "),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.contractorRates
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "flex justify-flex-start items-center text-storm-gray text-sm font-medium mb-1",
                        },
                        [
                          _c("DollarIcon", {
                            staticClass: "pr-2 w-auto h-auto",
                          }),
                          _c(
                            "span",
                            {
                              staticClass:
                                "text-primary-black font-400 text-sm pr-2",
                            },
                            [_vm._v("Rate")]
                          ),
                          _vm._v(_vm._s(_vm.contractorRates) + " "),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.contractorDate
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "flex justify-flex-start items-center text-storm-gray text-sm font-medium",
                        },
                        [
                          _c("CalendarIcon", {
                            staticClass: "pr-2 w-auto h-auto",
                          }),
                          _c(
                            "span",
                            {
                              staticClass:
                                "text-primary-black font-400 text-sm pr-2",
                            },
                            [_vm._v("Requested on")]
                          ),
                          _vm._v(_vm._s(_vm.contractorDate) + " "),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._t("requestedBy"),
                ],
                2
              ),
            ]),
          ]),
          _c(
            "div",
            {
              staticClass:
                "flex flex-col w-full items-center bg-white border-t border-gray-200 adjustFlexWidth",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "flex gap-1 w-full skills-footer items-center px-4 pt-4 mb-7",
                },
                [
                  _vm._v(" Skills: "),
                  _vm.contractorSkills.length > 0
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-row gap-1 flex-wrap items-center",
                        },
                        [
                          _vm._l(
                            _vm.contractorSkills.slice(0, 3),
                            function (skill) {
                              return _c(
                                "div",
                                { key: skill.id, staticClass: "skills-chip" },
                                [_vm._v(" " + _vm._s(skill.name) + " ")]
                              )
                            }
                          ),
                          _vm.contractorSkills.length > 3
                            ? _c("div", [
                                _c("div", { staticClass: "skills-chip-plus" }, [
                                  _vm._v(
                                    " +" +
                                      _vm._s(_vm.contractorSkills.length - 3) +
                                      " "
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ],
                        2
                      )
                    : _c("div", [_vm._v("n/a")]),
                ]
              ),
              _c("div", { staticClass: "w-full flex items-center p-4 pt-0" }, [
                _c(
                  "div",
                  { staticClass: "flex flex-col adjustFlexWidth" },
                  [
                    _c(
                      "RouterLink",
                      {
                        staticClass: "adjustFlexWidth",
                        attrs: {
                          to: {
                            name: _vm.routes.CONTRACTOR_DETAILS_ABOUT,
                            params: { id: _vm.contractor.id },
                          },
                        },
                      },
                      [
                        _c("UiButton", {
                          staticClass: "mb-4",
                          attrs: {
                            variant: "black",
                            buttonText: "Add to company",
                            buttonClasses: "customButtonCard",
                            fullWidth: true,
                          },
                        }),
                      ],
                      1
                    ),
                    _c("UiButton", {
                      attrs: {
                        fullWidth: true,
                        variant: "outline",
                        buttonText: "View profile",
                        buttonClasses: "customButtonCard",
                      },
                      on: { click: _vm.handleRestoreContractor },
                    }),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }